import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "vue-share-cart-button" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn1.idek.cz/file/link-361e1c5b.svg",
  width: "14",
  height: "14"
}, null, -1)
const _hoisted_4 = {
  key: 1,
  class: "dek-button-green dek-button-small",
  role: "button"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn1.idek.cz/file/check-0596c68b.svg",
  width: "14",
  height: "14"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ([_ctx.State.defualt, _ctx.State.pending].includes(_ctx.state) )
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "dek-button-white dek-button-small",
          role: "button",
          disabled: _ctx.state === _ctx.State.pending,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.save()))
        }, [
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(_ctx.t('default')), 1)
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.state === _ctx.State.success)
      ? (_openBlock(), _createElementBlock("button", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", null, _toDisplayString(_ctx.t('success')), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}